<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Born on a Rotten Day: Illuminating and Coping with the Dark Side of the Zodiac, by Hazel Dixon-Cooper." class="imagefp" src="images/9781439188705.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?a68d85a0